<template>
	<div class="d-flex flex-column" style="gap:8px">
		<div id="howtowrapper" class="d-flex align-items-center" v-html="content"></div>
	</div>
</template>

<script>
export default {
	props: {
		content: String,
	},
};
</script>

<style scoped>
::v-deep #howtowrapper ol {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	counter-reset: item;
  margin-top: 5px;
}
::v-deep #howtowrapper ol li {
	list-style-type: none;
	position: relative;
}
::v-deep #howtowrapper ol li:before {
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	border-radius: 100%;
	min-width: 24px;
	min-height: 24px;
	color: #fff;
	background-color: #5f51a1;
	position: absolute;
	left: -30px;
	top: -5px;
	counter-increment: item;
	content: counter(item);
}
</style>
